import { useState, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Topbar } from './Topbar'
import { CommandPalette } from '../CommandPalette'
import { ChatWidget } from '../chat/ChatWidget'
import { QuickCreate } from '../QuickCreate'
import { AmbientGlow } from '../ui/AmbientGlow'
import { CustomizerPanel, restoreCustomizations } from '../CustomizerPanel'
import { useLayoutStore } from '../../store/layout'

export function Shell() {
  const [cmdOpen, setCmdOpen] = useState(false)
  const [customizerOpen, setCustomizerOpen] = useState(false)
  const hideShell = useLayoutStore(s => s.hideShell)

  // Restore accent/density preferences on mount
  useEffect(() => { restoreCustomizations() }, [])

  if (hideShell) {
    return <Outlet />
  }

  return (
    <div className="shell">
      <Sidebar onOpenCustomizer={() => setCustomizerOpen(true)} />
      <div className="shell-main">
        <Topbar onCmdOpen={() => setCmdOpen(true)} />
        <div className="shell-content">
          <AmbientGlow />
          <div style={{ position: 'relative', zIndex: 1 }}>
            <Outlet />
          </div>
        </div>
      </div>
      <CommandPalette open={cmdOpen} onOpenChange={setCmdOpen} />
      <QuickCreate />
      <ChatWidget />
      <CustomizerPanel open={customizerOpen} onClose={() => setCustomizerOpen(false)} />
    </div>
  )
}
